import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';
import { ProductRequestDTO } from 'src/app/shared/models/dtos/requests/product-request-dto/product-request-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-product-created-modal',
  templateUrl: './product-created-modal.component.html',
  styleUrls: ['./product-created-modal.component.scss'],
})
/**
 * Comp onent for displaying a modal when a product is created.
 */
export class ProductCreatedModalComponent implements OnInit {
  labels = {
    added: 'product-added-sucessfully',
    canEdit: 'product-edit-details',
    canReturn: 'product-can-return',
    addReward: 'add-reward',
    productCreated: 'product-created',
    returnToControl: 'product-return',
  };
  /**
   * Initializes the ProductCreatedModalComponent.
   */
  constructor(
    private dialogRef: MatDialogRef<ProductCreatedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProductRequestDTO,
    private translationService: TranslationService,
    private router: Router
  ) {}

  /**
   * Initializer
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
  }

  /**
   * Closes the modal and returns a success response to redirect to control panel.
   */
  goToControlPanel() {
    this.dialogRef.close(MatDialogResponse.SUCCESS);
  }

  /**
   * Closes the modal and returns a failure response to indicate redirect to rewards addition.
   */
  goToAddRewards() {
    this.dialogRef.close(MatDialogResponse.FAIL);
    this.router.navigate([RoutesKeys.REWARD_DETAIL], {
      state: { product: this.data },
    });
  }
}
